import { defineStore } from 'pinia';
import router from '@/router';
import { API } from '@/services';
import { LOGOUT_USER_MUTATION, INVITE_CODE_STATUS_MUTATION } from '@/services/auth/mutations/index.js';
import Cookie from 'js-cookie';
import { useRoute, RouterLink } from 'vue-router';

export const useAuthStore = defineStore({
  id: 'auth',
  state: () => ({
    isNewUser: false,
    isLoading: false,
    isLoadingInvite: false,
    isOAuthBtnLoading: false,
    provider: false,
    forgotPasswordRequested: false,
    passwordUpdated: false,
    isOAuthWindowOpened: false,
    isOAuthUserConnecting: false,
    icarusMultipartConfig: null,
    inviteData: null,
    errors: null
  }),
  actions: {
    async logout() {
      try {
        this.isLoading = true;
        const redirectPath = sessionStorage.getItem('redirectPath') ?? false;
        if (Cookie.get('_pup_access_token')) {
          await API.sendQuery('/graphql/user', LOGOUT_USER_MUTATION);
          Cookie.remove('_pup_access_token');
          Cookie.remove('_pup_user');
          localStorage.removeItem('_pup_new_user');
          localStorage.removeItem('_pup_new_account');
          localStorage.removeItem('_pup_new_account_company_name');
          localStorage.removeItem('_new_account_invited_team_members');
          localStorage.removeItem('_pup_new_account_company_name');
          localStorage.removeItem('_pup_active_workspace');
          localStorage.removeItem('_pup_active_account');
          localStorage.removeItem('_pup_active_settings_workspace');
          localStorage.removeItem('_pup_active_settings_account');
          sessionStorage.removeItem('redirectPath');
          this.user = null;
        }
        if (redirectPath)
        {
          router.push({ path : '/login', query : { url : redirectPath }});
        } else {
          router.push( '/login' );
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async login(loginToken) {
      try {
        Cookie.set('_pup_access_token', loginToken, {
          expires: 7,
          sameSite: 'strict',
          secure: true
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getInviteData(token) {
      try{
        this.isLoadingInvite = true;

        if(this.token == token){
          return true;
        }

        this.inviteData = {loading: true};

        this.token = token;

        const res = await API.sendQuery('/graphql', INVITE_CODE_STATUS_MUTATION, { token });
        
        this.inviteData.loading = false;

        if (res.data.data.inviteCodeStatus) {
          this.inviteData = res.data.data.inviteCodeStatus;
              
          this.isLoadingInvite = false;
        }

        if(res.data.errors) {
          this.errors = res.data.errors;
          this.isLoadingInvite = false;
        }

        return true;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingInvite = false;
      }
    },
    isAuth() {
      let token = Cookie.get('_pup_access_token');
      return !!token;
    }
  }
});
